<template>
    <div
        id="manage-school-section"
        class="flex flex-col xl:flex-row w-full max-w-lg xl:max-w-3xl mx-auto system-text-color rounded-lg overflow-hidden"
    >
        <ul class="menus flex xl:block m-0 p-0">
            <li
                v-for="(menu, index) in menus"
                @click="onClickMenu(menu)"
                :key="index"
                :class="{
                    'flex-1 xl:flex-none flex justify-center xl:justify-start items-center p-4 cursor-pointer': true,
                    active: activeMenu.slug === menu.slug
                }"
            >
                <i :class="menu.icon"></i>
                <span class="hidden xl:block">{{ menu.label }}</span>
            </li>
        </ul>
        <div class="flex-1 overflow-hidden">
            <ManageUsers v-if="activeMenu.slug === 'users'" />
            <ManageQuizzes
                v-if="activeMenu.slug === 'quizzes'"
                @open-quiz-preview="$emit('open-quiz-preview', $event)"
                :register-slug="registerSlug"
            />
            <ManageSubjects v-if="activeMenu.slug === 'subjects'" />
            <ManageRequests v-if="activeMenu.slug === 'requests'" />
            <ManageSettings v-if="activeMenu.slug === 'settings'" />
        </div>
    </div>
</template>

<script>
import ManageUsers from '@/components/manage-school/ManageUsers'
import ManageQuizzes from '@/components/manage-school/ManageQuizzes'
import ManageSubjects from '@/components/manage-school/ManageSubjects'
import ManageRequests from '@/components/manage-school/ManageRequests'
import ManageSettings from '@/components/manage-school/ManageSettings'
import introJsData from '@/mixins/introjs-data'
import { startIntroManageSchool } from '@/lib/intro.js'

export default {
    components: {
        ManageUsers,
        ManageQuizzes,
        ManageSubjects,
        ManageRequests,
        ManageSettings
    },

    mixins: [introJsData],

    props: {
        registerSlug: {
            type: String,
            required: true
        }
    },

    data() {
        return {
            activeMenu: null,
            menus: [
                {
                    icon: 'fas fa-users-cog',
                    label: this.$t('manage_school_menu_users'),
                    slug: 'users'
                },
                {
                    icon: 'fas fa-shapes',
                    label: this.$t('manage_school_menu_quizzes'),
                    slug: 'quizzes'
                },
                {
                    icon: 'fas fa-book',
                    label: this.$t('manage_school_menu_subjects'),
                    slug: 'subjects'
                },
                {
                    icon: 'fas fa-bell',
                    label: this.$t('manage_school_menu_requests'),
                    slug: 'requests'
                },
                {
                    icon: 'fas fa-cog',
                    label: this.$t('manage_school_menu_settings'),
                    slug: 'settings'
                }
            ]
        }
    },

    created() {
        const menus = this.menus.map(menu => {
            return menu.slug
        })

        if (menus.includes(this.$route.query.menu)) {
            this.activeMenu = this.menus.find(menu => menu.slug === this.$route.query.menu)
        } else {
            this.activeMenu = this.menus[0]
        }
    },

    mounted() {
        setTimeout(() => {
            startIntroManageSchool(this.stepTour14)
        }, 700)
    },

    computed: {
        header() {
            return this.activeMenu.label
        }
    },

    methods: {
        onClickMenu(menu) {
            const urlParams = new URL(window.location.href)
            urlParams.searchParams.set('menu', menu.slug)
            urlParams.searchParams.delete('page')

            window.history.replaceState(null, null, urlParams.toString())

            this.activeMenu = menu
        }
    }
}
</script>

<style lang="scss">
#manage-school-section {
    height: 48rem;
    border: 2px solid var(--ui-primary-color);

    .menus {
        width: 100%;
        list-style: none;
        border-bottom: 2px solid var(--ui-primary-color);

        @media screen and (min-width: 1200px) {
            width: 20%;
            border-bottom: none;
            border-right: 2px solid var(--ui-primary-color);
        }

        li {
            font-size: 1.25rem;
            column-gap: 0.5rem;
            transition: background-color 0.1s;

            &:hover {
                background-color: var(--button-background-primary-color-hover);
            }

            &:active,
            &.active {
                background-color: var(--ui-primary-color);
                color: var(--ui-secondary-color);
            }

            @media screen and (min-width: 1200px) {
                font-size: 1rem;
            }
        }
    }

    .close-loader {
        width: 16px;
        height: 16px;
        border: 3px solid #fff;
        border-bottom-color: transparent;
        border-radius: 50%;
        display: inline-block;
        box-sizing: border-box;
        animation: rotation 1s linear infinite;
    }

    @keyframes rotation {
        0% {
            transform: rotate(0deg);
        }
        100% {
            transform: rotate(360deg);
        }
    }
}
</style>